// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"_3f6cebb"};